import type { HTMLAttributes } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { ScreenSizeRadioGroup } from "@circle-react-shared/ScreenSizeRadioGroup";

interface CanvasSizeToggleProps extends HTMLAttributes<HTMLDivElement> {}

export const CanvasSizeToggle = ({
  className,
  ...props
}: CanvasSizeToggleProps) => {
  const canvasSize = useBuilderStore(state => state.canvasSize);
  const setCanvasSize = useBuilderStore(state => state.setCanvasSize);

  return (
    <div
      className={classNames("bg-primary rounded-xl p-1", className)}
      {...props}
    >
      <ScreenSizeRadioGroup selected={canvasSize} onChange={setCanvasSize} />
    </div>
  );
};
